/** @format */

import { Injectable } from '@angular/core';
import { EmitEvent, EventBusService, Events } from './event-bus.service';

@Injectable({
  providedIn: 'root',
})
export class DeferredEventEmitterService {
  constructor(private eventBusService: EventBusService) {}

  onLoaded(promise: Promise<any>, event: Events): void {
    if (promise) {
      promise.finally(() => {
        this.emitEvent(event);
      });
    }
  }

  /**
   * @description
   * Emits certain event using the eventBusService.
   * It receives as an argument the event type that is going to be emitted.
   */
  private emitEvent(event: Events): void {
    this.eventBusService.emit(new EmitEvent(event));
  }
}
